import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Field, reduxForm, change, touch } from 'redux-form';


//Actions
import { GetCategoriesByCommunityId, AddCategory, GetCategoryIcons, UpdateCategory, GetIcons } from '../../actions/categoryActions'

//material ui
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { ChromePicker } from 'react-color'
import { Tab, Tabs } from '@material-ui/core';
import SwipeableViews from 'react-swipeable-views';
import Box from '@material-ui/core/Box';

//Engage Components
import {
    renderTextField
} from '../../utils/engageComponents';
import { sweetAlert } from '../../components/Alert/sweetAlert';
import { IconsModal } from './IconsModal';
import { Switch } from '@material-ui/core';



const validate = (values, props) => {
    const errors = {};


    if (!values.CategoryName) {
        errors.CategoryName = 'category name is required'
    }

    if (!values.CategoryColor) {
        errors.CategoryColor = 'category color is required'
    }

    // if(!values.CategoryIconUrl){
    //     errors.CategoryIconUrl='icon is required'
    // }


    const color = values.CategoryColor ? values.CategoryColor + '' : undefined;
    const colorsInUse = values.categoriesData ? values.categoriesData.map(cat => cat.categoryColor) : [];

    if (props.category === undefined) {

        if (color && colorsInUse) {

            if (!validateColorAvialability(color, colorsInUse)) {
                errors.CategoryColor = 'color not available';
            }
        }
    }


    return errors;
};


const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={1}>
                    <Grid>{children}</Grid>
                </Box>
            )}
        </div>
    );
};


//#region Methods
const validateColorAvialability = (color, colorsInUse) => {

    const isInUse = !!!colorsInUse.find(hex => {
        return hex === color;
    });

    return isInUse

};
//#endregion



export class AddCategoryModal extends Component {
    constructor(props) {
        super()

        this.state = {
            //communityId
            communityId: props.communityId,
            //defaultColor
            defaultColor: '#959494',
            //ColorPicker
            displayColorPicker: false,
            colorSelected: undefined,
            //categoryIconSelected
            categoryIconSelected: undefined,
            categoryIconSelectedUrl: undefined,
            //Category Badge
            categoryBadge: undefined,
            //Category value
            categoryValue: undefined,
            _id: (props.category) ? props.category._id : undefined,
            //icons combo
            openIconsCombo: false,
            //Icons modal
            openIconsModal: false,

            //Translations states
            openTranslations: false,
            tab: 0,
            nameEs: '',
            nameFr: ''

        }

        if (props.category) {
            props.dispatch(change('AddCategoryForm', 'categoriesData', props?.categoriesData ? props.categoriesData : ''));
            props.dispatch(change('AddCategoryForm', 'CategoryName', props.category.name));
            props.dispatch(change('AddCategoryForm', 'CategoryColor', props.category.categoryColor));
            props.dispatch(change('AddCategoryForm', 'CategoryIconUrl', props.category.iconUrl));
        } else {
            props.dispatch(change('AddCategoryForm', 'categoriesData', props?.categoriesData ? props.categoriesData : ''));
            props.dispatch(change('AddCategoryForm', 'CategoryName', ''));
            props.dispatch(change('AddCategoryForm', 'CategoryColor', ''));
            props.dispatch(change('AddCategoryForm', 'CategoryIconUrl', ''));
        }


    };

    componentDidMount() {
        const communityId = (localStorage.getItem('communityId')) ? localStorage.getItem('communityId') : undefined;

        if (communityId && communityId.length > 0) {
            this.props.GetCategoriesByCommunityId(communityId)
            this.props.GetIcons();
        }

        if (this.props.category) {

            this.setState({
                colorSelected: this.props.category.categoryColor,
                categoryBadge: this.GetCategoryBadge(this.props.category.name),
                categoryValue: this.props.category.name,
                categoryIconSelected: this.props.categoryIconsData.find(item => item.iconUrl === this.props.category.iconUrl),
                categoryIconSelectedUrl: this.props.category.iconUrl
            })


            const { translations } = this.props.category;


            if (translations && translations.length > 0) {

                const spanishObj = translations.find(x => x.languageCode === 'es');

                const frenchObj = translations.find(x => x.languageCode === 'fr');

                if (spanishObj) {
                    this.setState({ nameEs: spanishObj.name });

                    this.props.dispatch(change('AddCategoryForm', 'nameEs', spanishObj.name));

                }

                if (frenchObj) {
                    this.setState({ nameFr: frenchObj.name });
                    this.props.dispatch(change('AddCategoryForm', 'nameFr', frenchObj.name));

                }

            }
        }
    };



    //#region Modal

    modalWidth = 35;
    modalHeight = 85;

    Modal = {
        paperModal: {
            backgroundColor: '#1f1f1f',
            padding: '6px',
            width: this.modalWidth + '%',
            height: this.modalHeight + '%',
            position: 'relative',
            top: '10%',
            left: '35%',
            overflowY: 'scroll'
        },
        stepperModal: {
            height: '10%',
        },
        contentModal: {
            height: '80%',
            padding: '20px'
        },
        buttonsModal: {
            height: '20%',
            justify: 'center',
        },
        hiddenButton: {
            display: 'none'
        },
        visibleButton: {
            marginBottom: '20px'
        },
        visibleDisabledButton: {
            marginBottom: '20px',
            backgroundColor: '#ffffff',
            color: '#bdbdbd'
        }
    }
    //#endregion

    handleClick = () => {
        if (!this.state.displayColorPicker) {
            setTimeout(() => {
                this.setIdsChromePicker()
            }, 200);
        }

        this.setState({ displayColorPicker: !this.state.displayColorPicker });


    };

    setIdsChromePicker = (index = 0) => {

        let container = document.getElementsByClassName('chrome-picker')

        if (container && container.length > 0) {
            container = container[0];

            let divs = container.getElementsByTagName('*')

            const id = `chromePicker_inputId`

            switch (index) {
                case 0:
                    if (divs && divs.length >= 36) {
                        const input = divs[32];
                        const label = divs[33];
                        const arrow = divs[36];

                        if (input) {
                            input.setAttribute('id', id);
                        }

                        if (label) {
                            label.setAttribute('for', id);
                        }

                        if (arrow) {
                            arrow.setAttribute('id', `${id}_arrow`);

                            arrow.addEventListener("click", () => setTimeout(() => {
                                this.setIdsChromePicker(index + 1);
                            }, 200)
                            );

                        }


                    }

                    break;
                case 1:
                    if (divs && divs.length >= 48) {
                        const inputR = divs[32];
                        const labelR = divs[33];
                        const inputG = divs[36];
                        const labelG = divs[37];
                        const inputB = divs[40];
                        const labelB = divs[41];
                        const inputA = divs[44];
                        const labelA = divs[45];
                        const arrow = divs[48];

                        const id = `chromePicker_inputId`

                        if (inputR) {
                            inputR.setAttribute('id', `${id}_inputR`);
                        }

                        if (labelR) {
                            labelR.setAttribute('for', `${id}_inputR`);
                        }

                        if (inputG) {
                            inputG.setAttribute('id', `${id}_inputG`);
                        }

                        if (labelG) {
                            labelG.setAttribute('for', `${id}_inputG`);
                        }

                        if (inputB) {
                            inputB.setAttribute('id', `${id}_inputB`);
                        }

                        if (labelB) {
                            labelB.setAttribute('for', `${id}_inputB`);
                        }

                        if (inputA) {
                            inputA.setAttribute('id', `${id}_inputA`);
                        }

                        if (labelA) {
                            labelA.setAttribute('for', `${id}_inputA`);
                        }

                        if (arrow) {
                            arrow.setAttribute('id', `${id}_arrow`);

                            arrow.addEventListener("click", () => setTimeout(() => {
                                this.setIdsChromePicker(index + 1);
                            }, 200)
                            );

                        }

                    }
                    break;
                case 2:
                    if (divs && divs.length >= 48) {
                        const inputR = divs[32];
                        const labelR = divs[33];
                        const inputG = divs[36];
                        const labelG = divs[37];
                        const inputB = divs[40];
                        const labelB = divs[41];
                        const inputA = divs[44];
                        const labelA = divs[45];
                        const arrow = divs[48];

                        const id = `chromePicker_inputId`

                        if (inputR) {
                            inputR.setAttribute('id', `${id}_inputR`);
                        }

                        if (labelR) {
                            labelR.setAttribute('for', `${id}_inputR`);
                        }

                        if (inputG) {
                            inputG.setAttribute('id', `${id}_inputG`);
                        }

                        if (labelG) {
                            labelG.setAttribute('for', `${id}_inputG`);
                        }

                        if (inputB) {
                            inputB.setAttribute('id', `${id}_inputB`);
                        }

                        if (labelB) {
                            labelB.setAttribute('for', `${id}_inputB`);
                        }

                        if (inputA) {
                            inputA.setAttribute('id', `${id}_inputA`);
                        }

                        if (labelA) {
                            labelA.setAttribute('for', `${id}_inputA`);
                        }

                        if (arrow) {
                            arrow.setAttribute('id', `${id}_arrow`);

                            arrow.addEventListener("click", () => setTimeout(() => {
                                this.setIdsChromePicker(index + 1);
                            }, 200)
                            );

                        }

                    }
                    break;
                default:
                    break;
                }



        }
    }

    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };

    //onSubmit
    onSubmitHandler(formData) {

        if (this.state.communityId && this.state.communityId.length > 0) {

            let objToSend = {}

            objToSend.communityId = this.state.communityId;
            objToSend.name = formData.CategoryName;
            objToSend.description = '';
            objToSend.categoryColor = formData.CategoryColor;
            objToSend.iconResourceName = '';
            objToSend.iconUrl = this.state.categoryIconSelectedUrl;
            objToSend.solidIconUrl = this.state.categoryIconSelected.solidIconUrl;
            

            if (!this.state.categoryIconSelectedUrl) {
                sweetAlert('error', 'Please select an icon', 'alert_AddEditItem_CharacterLimit_Error');
                return;
            }

            objToSend.translations = [];

            if (this.state.nameEs !== '') {
                const spanishObj = {
                    
                    languageCode: 'es',
                    name: this.state.nameEs,
                }

                objToSend.translations.push(spanishObj);
            }

            if (this.state.nameFr !== '') {
                const frenchObj = {
                    languageCode: 'fr',
                    name: this.state.nameFr,
                }

                objToSend.translations.push(frenchObj);
            }


            if (this.state._id) { //Edit category

                this.props.UpdateCategory(this.state._id, objToSend)
                this.props.setUpdateIsNeeded(true);

            } else { //Add category

                this.props.AddCategory(objToSend);

            }

            this.closeModal();
        }

    };

    closeModal() {
        this.cleanModal();
        this.props.onClose();
    };

    cleanModal() {
        this.setState({
            //communityId
            communityId: undefined,
            //defaultColor
            defaultColor: '#959494',
            //ColorPicker
            displayColorPicker: false,
            colorSelected: undefined,
            //categoryIconSelected
            categoryIconSelectedUrl: undefined,
            categoryIconSelected: undefined,

        })


        this.props.dispatch(change('AddCategoryForm', 'CategoryName', ''));
        this.props.dispatch(change('AddCategoryForm', 'CategoryColor', ''));
        this.props.dispatch(change('AddCategoryForm', 'CategoryIconUrl', ''));
    };

    GetCategoryBadge(categoryName) {
        let categoryWords = categoryName.split(' ');

        categoryWords = categoryWords.filter(item => item !== '&');

        const CategoryBadge = categoryWords.map(word => word.charAt(0).toUpperCase()).join('').slice(0, 2);

        return CategoryBadge;
    };





    //#region Handlers
    handlerColorSelected = (color) => {
        this.setState({ colorSelected: color.hex });
        this.props.dispatch(change('AddCategoryForm', 'CategoryColor', color.hex));
        if (color && !this.state.colorSelected) {
            this.props.dispatch(touch('AddCategoryForm', 'CategoryColor'));
        }
    };
    ////#endregion

    //#region  Inner Components
    colorPickerComponent = (field) => {
        const device = this.props.rootFontSize ? this.props.rootFontSize.name : 'md';
        const mobile = (device === 'xs' || device === 'sm' || device === 'md') ? true : false;
        const sizecategoryColor = mobile ? '2rem' : '3rem';

        const error = field?.meta?.error ? field.meta.error : '';
        const touched = field?.meta?.touched ? field.meta.touched : '';

        return (
            <>
                <Grid item container
                    id='add_category_color_btn'
                    justify='center'
                    alignItems='center'
                    onClick={this.handleClick}
                    style={
                        {
                            backgroundColor: this.state.colorSelected ? this.state.colorSelected : this.state.defaultColor,
                            marginTop: '10px',
                            color: 'white',
                            fontSize: '1rem',
                            width: sizecategoryColor,
                            height: sizecategoryColor,
                            borderRadius: '50%',
                        }
                    }
                >
                    <Grid item style={{ fontSize: '15px', color: '#F0EFEF', }} >Edit</Grid>
                </Grid>

                <Grid item xs={12} style={{ fontSize: '12px', color: '#f44336' }}>
                    {
                        touched && error
                    }
                </Grid>
            </>
        )
    }
    //#endregion

    handleIconsCombo = (e, option) => {
        if (!option) {

            this.setState((prevState) => ({ openIconsCombo: !prevState.openIconsCombo }));
        } else {
            this.setState({ openIconsCombo: option });
        }
    }

    handleIconsComboOnBlur = () => {
        this.setState({ openIconsCombo: false })
    }

    handleSelectIcon = (iconObj) => {

        if (iconObj) {
            const iconUrl = iconObj && iconObj.iconUrl ? iconObj.iconUrl : '';

            this.setState({ categoryIconSelected: iconObj, categoryIconSelectedUrl: iconUrl, openIconsModal: false })
            this.props.dispatch(change('AddCategoryForm', 'CategoryIconUrl', iconObj));
        }
    }

    handleChangeTab = (event, newValue) => {
        this.setState({ tab: newValue });
    };

    a11yProps(lng) {
        return {
            id: `vertical-translation-tab-${lng}`,
            'aria-controls': `vertical-tabpanel-${lng}`,
        };
    }

    handleChangeTranslationIndex = (index) => {
        this.setState({ tab: index })
    }


    render() {
        const device = this.props.rootFontSize ? this.props.rootFontSize.name : 'md';
        const mobile = (device === 'xs' || device === 'sm' || device === 'md') ? true : false;
        const sizecategoryColor = mobile ? '2rem' : '3rem';

        const thumbClass = this.state.openTranslations ? 'switchThumbChecked' : 'switchThumb'
        const trackClass = this.state.openTranslations ? 'switchTrackChecked' : 'switchTrack'

        const popover = {
            position: 'absolute',
            zIndex: '2',
        }
        const cover = {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
        }


        const buttonStyle = {
            borderRadius: '25px',
            backgroundColor: '#959494',
            width: '9rem',
            fontSize: '1rem',
            fontWeight: 'bold',
            color: 'white',
            textAlign: 'center',
            textTransform: 'none'
        }

        return (
            <>
                <Modal
                    style={{ zIndex: 18 }}
                    open={true}
                    onClose={() => this.props.onClose()}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                >
                    <Paper elevation={3} style={{ ...this.Modal.paperModal, width: mobile ? '50%' : '40%' }} color='secondary'>
                        <Grid container xs={12} style={{ padding: '22px' }} id='add_category_modal'>
                            <Grid item container xs={12} justify='flex-start' className='ModalTitle'>
                                <Grid item container>
                                    {(this.state._id) ? 'Edit category' : 'Add Category'}
                                </Grid>
                            </Grid>
                            <Grid item container xs={12} justify='space-around' style={{ padding: '22px' }}>
                                <Grid item container xs={11} >
                                    {/* category name */}
                                    <Grid item container xs={12}>
                                        <Field
                                            id='add_category_name'
                                            name="CategoryName"
                                            label="Category"
                                            maxLength={20}
                                            component={renderTextField}
                                            onChange={(e, value) => this.setState({ categoryBadge: this.GetCategoryBadge(value), categoryValue: value })}
                                            inputClass='inputClass'
                                        />
                                    </Grid>

                                    <Grid item container xs={12} alignItems='center' justify='flex-end' style={{ marginTop: '1rem' }}>

                                        <span style={{ fontWeight: 'bold', textAlign: 'left', fontSize: '20px', opacity: '.56', color: 'white', marginRight: '1rem' }}>Add other translations</span>
                                        <Switch
                                            classes={{
                                                root: 'switchRoot',
                                                thumb: thumbClass,
                                                track: trackClass,
                                            }}
                                            checked={this.state.openTranslations}
                                            onClick={() => this.setState((prevState) => ({ openTranslations: !prevState.openTranslations }))}>
                                        </Switch>

                                    </Grid>
                                    {
                                        this.state.openTranslations &&
                                        <Grid item container xs={12} className='setUpGridColum'>
                                            <Tabs
                                                value={this.state.tab}
                                                onChange={this.handleChangeTab}
                                                aria-label="Translations tab"
                                                className='translationTabs'
                                                variant='scrollable'
                                                TabIndicatorProps={{ style: { backgroundColor: '#009edd' } }}

                                            >
                                                <Tab label="ES" className={(this.state.tab === 0) ? "SelectedTranslationTabs" : "translationTab"} {...this.a11yProps(0)} />
                                                <Tab label="FR" className={(this.state.tab === 1) ? "SelectedTranslationTabs" : "translationTab"} {...this.a11yProps(1)} />
                                            </Tabs>

                                            <SwipeableViews
                                                axis='x'
                                                index={this.state.tab}
                                                onChangeIndex={this.handleChangeTranslationIndex}
                                            >

                                                <TabPanel value={0} index={0} className='translationTabContent'>
                                                    <Grid item container xs={12}>
                                                        <Field
                                                            name="nameEs"
                                                            label="Categoria"
                                                            maxLength={20}
                                                            onChange={(e, newItem) => this.setState({ nameEs: newItem })}
                                                            component={renderTextField}
                                                            id='category_name_es'
                                                        />

                                                    </Grid>
                                                </TabPanel>

                                                <TabPanel value={1} index={1} className='translationTabContent'>
                                                    <Grid item container xs={12}>
                                                        <Field
                                                            name="nameFr"
                                                            label="Catégorie"
                                                            maxLength={20}
                                                            onChange={(e, newItem) => this.setState({ nameFr: newItem })}
                                                            component={renderTextField}
                                                            id='category_name_fr'
                                                        />

                                                    </Grid>
                                                </TabPanel>

                                            </SwipeableViews>
                                        </Grid>
                                    }

                                    <Grid item container xs={12}>
                                        <Grid item className='ModalSeccion' style={{ paddingLeft: '25px' }}>
                                            Already in Use
                                            <Grid direction='row' item container xs={12} justify='flex-start' style={{ marginTop: '10px' }}>
                                                {
                                                    (this.props.categoriesData && this.props.categoriesData.length > 0) ?
                                                        this.props.categoriesData.map(
                                                            item => {
                                                                return (
                                                                    <Grid style={{ padding: '5px' }}>
                                                                        <Grid style={{
                                                                            borderRadius: '50%',
                                                                            backgroundColor: item.categoryColor,
                                                                            width: sizecategoryColor,
                                                                            height: sizecategoryColor,

                                                                        }}>
                                                                        </Grid>
                                                                    </Grid>
                                                                )
                                                            }
                                                        )
                                                        :
                                                        undefined
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item container xs={12} justify='space-around' style={{ padding: '22px' }}>
                                        <Grid item container xs={11} >
                                            {/* Color picker */}
                                            <Grid item container xs={12} md={12} lg={6} justify='flex-start' direction='column' style={{ marginBottom: '25px' }}>
                                                <Grid item container justify='center'>
                                                    <Grid item className='ModalSeccion' >
                                                        {(this.state._id) ? 'Category Color' : 'New Category Color'}
                                                    </Grid>
                                                </Grid>
                                                <Grid>


                                                    <Grid item container xs={12} style={{ display: 'block' }} >
                                                        <Field
                                                            name="CategoryColor"
                                                            label="CategoryColor"
                                                            maxLength={20}
                                                            component={this.colorPickerComponent}
                                                        />
                                                    </Grid>
                                                    {
                                                        this.state.displayColorPicker ?
                                                            <div style={popover}>
                                                                <div style={cover} onClick={this.handleClose} />
                                                                <ChromePicker
                                                                    id='color_picker'
                                                                    color={this.state.colorSelected}
                                                                    onChange={(color, e) => {
                                                                        this.handlerColorSelected(color);
                                                                    }}
                                                                />
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </Grid>


                                            </Grid>

                                            {/* Icon combo */}
                                            {/* <Grid item container xs={12} md={12} lg={6} justify='flex-start' direction='column'  style={{marginBottom:'25px'}}>
                                <Grid item container justify='center' >
                                    <Grid item className='ModalSeccion'>
                                        Icon
                                    </Grid>
                                </Grid>
                                <Grid item container style={{marginTop:'10px',color:'white', fontSize:'1rem', height:'4rem'}}>
                                <Field
                                    name="CategoryIconUrl"
                                    label={''}
                                    onChangeHandler={(e, obj) => { 
                    
                                        const iconUrl = obj && obj.iconUrl? obj.iconUrl : '';

                                        this.setState({categoryIconSelected: obj,  categoryIconSelectedUrl: iconUrl})
                                        this.props.dispatch(change('AddCategoryForm','CategoryIconUrl', obj));                  
                                        this.handleIconsCombo(null,false);
                                    }}
                                    optionsItemsIconsData={this.props.categoryIconsData}
                                    selected={this.state.categoryIconSelected? this.state.categoryIconSelected  : {name:''}}
                                    disabled= {false}
                                    readOnly={true}
                                    maxLength={20}
                                    autoCompleteStyles={{paddingRight:'0px'}}
                                    component={renderThumbnailSelect}
                                    showStartAdornment={true}
                                    onClick={this.handleIconsCombo}
                                    onBlur={this.handleIconsComboOnBlur}
                                    open={this.state.openIconsCombo}
                                />  
                                                                    
                                </Grid>
                               
                            </Grid> */}
                                            <Grid item container xs={12} md={12} lg={6} justify='flex-start' direction='column'>
                                                <img
                                                    src={this.state.categoryIconSelectedUrl}
                                                    alt='No Icon selected'
                                                    className="iconStyle"
                                                />
                                                <Button id='select_icon_btn' variant='filled' className="SelectIconBtn textTransform" onClick={() => { this.setState((prevState) => ({ openIconsModal: !prevState.openIconsModal })); }}>
                                                    Select Icon
                                                </Button>
                                            </Grid>

                                            {/* Screen Preview  and PDF Preview   */}
                                            <Grid item container xs={12} >
                                                {/* Screen preview */}
                                                <Grid item container xs={12} md={12} lg={6} >
                                                    <Grid item container xs={12}
                                                        justify='center'
                                                    >
                                                        <Grid item className='ModalSeccion'>
                                                            Screen Preview
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item container xs={12}
                                                        style={{
                                                            //maxWidth:'18rem',
                                                            backgroundColor: 'transparent',
                                                            height: '4rem',
                                                            marginTop: '10px',
                                                            fontSize: '1rem',
                                                            borderRadius: '9px',
                                                        }} >
                                                        <Grid item container xs={3} style={{ padding: '10px', }} justify='center' alignItems='center'>
                                                            <Grid item container
                                                                justify='center'
                                                                alignItems='center'
                                                                style={{
                                                                    backgroundColor: this.state.colorSelected ? this.state.colorSelected : this.state.defaultColor,
                                                                    color: 'white',
                                                                    fontWeight: 'bold',
                                                                    width: '35px',
                                                                    height: '35px',
                                                                    textAlign: 'center',
                                                                    borderRadius: '50%'
                                                                }}>
                                                                <Grid item>{this.state.categoryBadge ? this.state.categoryBadge : 'C'}</Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item container xs={9} alignItems='center' className='inputClass' style={{ color: this.state.colorSelected }}>
                                                            <Grid item style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>{this.state.categoryValue ? this.state.categoryValue : 'Category'}</Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                {/* PDF preview */}
                                                <Grid item container xs={12} md={12} lg={6} >
                                                    <Grid item container
                                                        justify='center'
                                                    >
                                                        <Grid item className='ModalSeccion'>
                                                            PDF Preview
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item container xs={12}
                                                        style={{
                                                            //maxWidth:'18rem',
                                                            backgroundColor: '#f0efef',
                                                            height: '4rem',
                                                            marginTop: '10px',
                                                            fontSize: '1rem',
                                                            borderRadius: '9px',
                                                        }}
                                                    >
                                                        <Grid item container xs={3} style={{ padding: '10px', }} justify='center' alignItems='center'>
                                                            <Grid item container
                                                                justify='center'
                                                                alignItems='center'
                                                                style={{
                                                                    backgroundColor: this.state.colorSelected ? this.state.colorSelected : this.state.defaultColor,
                                                                    color: 'white',
                                                                    fontWeight: 'bold',
                                                                    width: '35px',
                                                                    height: '35px',
                                                                    textAlign: 'center',
                                                                    borderRadius: '50%'
                                                                }}>
                                                                <Grid item>{this.state.categoryBadge ? this.state.categoryBadge : 'C'}</Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item container xs={9} alignItems='center' justify='center' className='inputClass' style={{ color: this.state.colorSelected }}>
                                                            <Grid item style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', }} >{this.state.categoryValue ? this.state.categoryValue : 'Category'}</Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            {/* tip */}
                                            {
                                                this.state._id === undefined &&
                                                <Grid item container xs={12} justify='center' style={{ color: '#747373', fontSize: '.7rem', paddingTop: '20px' }}>
                                                    <Grid item container xs={10} >Tip: Choose a color that is different from already used colors and that is easy to view for screens and printing</Grid>
                                                </Grid>
                                            }

                                            {/* buttons */}
                                            <Grid item container xs={12} justify='center' style={{ paddingTop: '40px' }}>
                                                <Grid item container xs={12} spacing={2} justify='center' alignItems='center'>
                                                    <Grid item>
                                                        <Button id='add_category_cancel_btn' style={{ ...buttonStyle }} onClick={() => this.closeModal()}>
                                                            Cancel
                                                        </Button>
                                                    </Grid>
                                                    <Grid item>
                                                        <Button id='add_category_save_btn' style={{ ...buttonStyle, backgroundColor: '#009edd' }}
                                                            onClick={this.props.handleSubmit(this.onSubmitHandler.bind(this))}>
                                                            {
                                                                this.state._id ? 'Save' : 'Add'
                                                            }
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </Modal>


                {
                    this.state.openIconsModal === true ?

                        <IconsModal
                            icons={this.props.IconsData}
                            onSelectIcon={this.handleSelectIcon}
                            iconSelected={this.state.categoryIconSelected}
                            onClose={() => { this.setState({ openIconsModal: false }) }}
                        />
                        :
                        undefined
                }

            </>
        );
    }
}


function mapStateToProps(state) {

    const categoryData = (state.categoryReducer && state.categoryReducer.categoryData) ? state.categoryReducer.categoryData : [];
    const categoryIconsData = (state.categoryReducer && state.categoryReducer.categoryIconsData) ? state.categoryReducer.categoryIconsData : [];
    const IconsData = (state.categoryReducer && state.categoryReducer.IconsData) ? state.categoryReducer.IconsData : [];

    return {
        categoriesData: categoryData,
        categoryIconsData: categoryIconsData,
        IconsData: IconsData
    };
};


export default connect(mapStateToProps, { GetCategoriesByCommunityId, AddCategory, GetCategoryIcons, UpdateCategory, GetIcons })(reduxForm({
    form: 'AddCategoryForm',
    validate,
    touchOnBlur: true,
    touchOnChange: true,
    enableReinitialize: true,
})(AddCategoryModal));